.trash {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.more {
  align-self: flex-start;
}
